"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TENANT_SERVICE = void 0;
var _gr = _interopRequireDefault(require("./gr"));
var _it = _interopRequireDefault(require("./it"));
var _cl = _interopRequireDefault(require("./cl"));
var _ie = _interopRequireDefault(require("./ie"));
var _sa = _interopRequireDefault(require("./sa"));
var _maac_ie = _interopRequireDefault(require("./maac_ie"));
var _pe = _interopRequireDefault(require("./pe"));
var _de = _interopRequireDefault(require("./de"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TENANT_SERVICE = {
  gr: {
    analytics: _gr.default.AnalyticsService,
    host: _gr.default.HostService
  },
  it: {
    analytics: _it.default.AnalyticsService,
    host: _it.default.HostService
  },
  ie: {
    analytics: _ie.default.AnalyticsService,
    host: _ie.default.HostService
  },
  cl: {
    analytics: _cl.default.AnalyticsService,
    host: _cl.default.HostService,
    windowAPI: _cl.default.WindowAPI
  },
  sa: {
    analytics: _sa.default.AnalyticsService,
    host: _sa.default.HostService
  },
  maac_ie: {
    analytics: _maac_ie.default.AnalyticsService,
    host: _maac_ie.default.HostService
  },
  pe: {
    analytics: _pe.default.AnalyticsService,
    host: _pe.default.HostService,
    windowAPI: _pe.default.WindowAPI
  },
  de: {
    analytics: _de.default.AnalyticsService,
    host: _de.default.HostService
  }
};
exports.TENANT_SERVICE = TENANT_SERVICE;